module.exports = __webpack_public_path__ + "img/banner.7d3634a7.png";